/**
 * EzTableコンポーネント群で使用するローディング状態の型定義
 */

/**
 * ローディング状態の型
 */
export type LoadingStatus = { type: 'loading' } | { type: 'success' } | { type: 'error'; errorMessage?: string } | { type: 'zero-match' };

/**
 * ローディング状態判定のヘルパー関数群
 */
export const loadingStatusHelpers = {
  /**
   * ローディング中かどうかを判定
   * @param status - ローディング状態
   * @returns ローディング中の場合true
   */
  isLoading(status: LoadingStatus): boolean {
    return status.type === 'loading';
  },

  /**
   * 成功状態かどうかを判定
   * @param status - ローディング状態
   * @returns 成功状態の場合true
   */
  isSuccess(status: LoadingStatus): boolean {
    return status.type === 'success';
  },

  /**
   * エラー状態かどうかを判定
   * @param status - ローディング状態
   * @returns エラー状態の場合true
   */
  isError(status: LoadingStatus): boolean {
    return status.type === 'error';
  },

  /**
   * ゼロマッチ状態かどうかを判定
   * @param status - ローディング状態
   * @returns ゼロマッチ状態の場合true
   */
  isZeroMatch(status: LoadingStatus): boolean {
    return status.type === 'zero-match';
  },

  /**
   * テーブルのコンテンツを表示すべきかどうかを判定
   * @param status - ローディング状態
   * @returns コンテンツを表示すべき場合true
   */
  shouldShowContent(status: LoadingStatus): boolean {
    return status.type === 'success';
  },
} as const;
